<template>
    <div class="upload-file">
        <div class="uf_lists">
            <template v-if="noResult">
                  <div class="uf_list uf_upload" @click="selectFile">
                <div class="icon-bg"></div>
                <div class="tip">{{ uploadTip }}</div>
            </div>
            </template>
            <template v-else>
            <div v-for="(file, index) in fileList" :key="index" :style="{width: width + 'px', height: height + 'px'}"
                 class="uf_list">
                <!--上传中-->
                <div v-if="file.status === 'uploading'" class="uploading">
                    <p class="icon-bg"></p>
                    <p class="tip">上传中</p>
                    <p :title="file.name" class="name">{{ file.name }}</p>
                </div>
                <!--上传成功-->
                <div v-if="file.status === 'success'" class="success">
                    <template v-if="type === 'img'">
                        <img :src="file.path" alt="" class="img" draggable="false">
                    </template>
                    <template v-else>
                        <p class="icon-bg"></p>
                        <p class="tip">上传成功</p>
                        <p :title="file.name" class="name">{{ file.name }}</p>
                    </template>
                    <p class="remove" @click="removeFile(index)"></p>
                </div>
                <!--上传失败-->
                <div v-if="file.status === 'error'" class="error">
                    <p class="icon-bg"></p>
                    <p class="tip">上传失败</p>
                    <p :title="file.name" class="name">{{ file.name }}</p>
                    <p class="remove" @click="removeFile(index)"></p>
                </div>
            </div>
            </template>
            <!--上传按钮-->
            <div v-if="fileList.length < max&&!noResult"
                 class="uf_list uf_upload" @click="selectFile">
                <div class="icon-bg"></div>
                <div class="tip">{{ uploadTip }}</div>
            </div>
            <input ref="el-input" :accept="accept" :multiple="max !== 1" hidden type="file" @change="selectedFile">
        </div>
    </div>
</template>

<script>
    import { getUploadAuth, uploadFile, uploadFileCheck, uploadFileMerge } from "./upload"
    import { getFileChunk } from "./file"
    import { computedMD5 } from "./md5"

    export default {
        name: "UploadFile",
        props: {
            // 上传的文件类型
            type: {
                type: String,
                default: "img",
                validator: value => ["img", "audio", "video","pdf"].includes(value)
            },
            // 最多上传数量
            max: {
                type: Number,
                default: 9
            },
            // 最大上传尺寸
            maxSize: {
                type: Number,
                default: 1024 * 1024 * 10
            },
            // 宽度
            width: {
                type: Number,
                default: 120
            },
            // 高度
            height: {
                type: Number,
                default: 120
            },
            // 上传的提示语
            tip: {
                type: String,
                default: ""
            },
            // 已上传的文件
            uploadedFileList: {
                type: Array,
                default: () => []
            },
            //下标
            dataIndex: {
                type:  Number || String ,
                default: ""
            },
            //不展示上传结果
            noResult: {
                type: Boolean ,
                default:false
            },
        },
        computed: {
            // 限制上传类型
            accept() {
                switch (this.type) {
                    case "img":
                        return "image/*"
                    case "audio":
                        return "audio/mp3,audio/mpeg,audio/basic,audio/3gpp,audio/ac3"
                    case "video":
                        return "video/*"
                    case "pdf":
                        return "application/pdf,application/msword,.doc,.docx"
                    default:
                        return ""
                }
            },
            // 上传提示语
            uploadTip() {
                const map = {
                    img: "上传图片",
                    audio: "上传音频",
                    video: "上传视频",
                    pdf: "上传PDF"
                }
                if (this.tip) {
                    return this.tip
                } else {
                    return map[this.type]
                }
            }
        },
        watch: {
            uploadedFileList: {
                immediate: true,
                handler(val) {
                    if (val.length) {
                        this.fileList = val.map(file => {
                            return {
                                ...file,
                                status: "success"
                            }
                        })
                    } else {
                        this.fileList = []
                    }
                    // this.emitRes()
                }
            }
        },
        data() {
            return {
                fileList: [],
                chunkSize: 1024 * 500
            }
        },
        methods: {
            // 弹出选择文件框
            selectFile() {
                this.$refs["el-input"].type = "text"
                this.$refs["el-input"].value = ""
                this.$refs["el-input"].type = "file"
                this.$refs["el-input"].click()
            },
            // 选择文件
            selectedFile(e) {
                let files = Array.from(e.target.files)
                 if(this.noResult){
                    this.init();
                }

                // 验证
                if (!this.verifyFile(files)) return

                // 对新上传的file进行一层包装，加上一些状态和必要的字段
                let newFileList = files.map(file => {
                    return {
                        name: file.name,
                        ext: file.name.split(".").reverse()[0].toLowerCase(),
                        status: "uploading",
                        size: file.size,
                        file
                    }
                })

                // 将新上传的file放入数组中，可以及时的在页面中显示出来，并且是等待状态
                this.fileList = [...this.fileList, ...newFileList]

                // 将当前组件正在上传文件的信息返回出去
                this.emitRes()

                // 上传文件
                newFileList.forEach(async file => {
                    await this.uploadFileSingle(file)
                })
            },
            // 验证文件数量和大小
            verifyFile(files) {
                if (files.length + this.fileList.length > this.max) {
                    this.$message.error(`最多上传${this.max}个文件${files.length ? `，已上传${files.length}个` : ""}`)
                    return false
                }
                if (files.some(file => file.size > this.maxSize)) {
                    this.$message.error(`不能上传大于${this.maxSize / 1024 / 1024}M的文件`)
                    return false
                }
                return true
            },
            // 上传单个文件
            async uploadFileSingle(file) {
                // 计算文件的MD5并将值付给包装对象上
                file.md5 = await computedMD5(file.file)

                // 获取加密值并将值付给包装对象上
                let auth = await getUploadAuth({
                    ext: file.ext,
                    size: file.size,
                    md5: file.md5
                })
                if (auth.code === 0) {
                    file.auth = auth.data.data
                } else {
                    this.uploadFileError(file, auth.msg || "获取加密值失败")
                    return
                }

                // 验证文件是否上传过，实现秒传
                let checkReq = {
                    sourceType: 15,
                    ext: file.ext,
                    size: file.size,
                    md5: file.md5,
                    auth: file.auth
                }
                if (this.type === "img") {
                    checkReq.img = 1
                }else if(this.type !== "video"){
                    checkReq.img = 2
                }
                let check = await uploadFileCheck(checkReq)
                if (check.code === 1) {
                    // 文件已上传过 秒传成功
                    this.uploadFileSuccess(file, check.data)
                    return
                } else if (check.code !== 1 && check.code !== 0) {
                    this.uploadFileError(file, check.msg || "文件验证失败")
                    return
                }

                // 开始上传文件，是否需要切片上传
                if (file.size <= 500 * 1024) {
                    // 文件小于1M 不切片
                    let fd = new FormData()
                    fd.append("sourceType", 15)
                    fd.append("md5", file.md5)
                    fd.append("ext", file.ext)
                    fd.append("size", file.size)
                    fd.append("auth", file.auth)
                    if (this.type === "img") {
                        fd.append("img", 1)
                    }else if(this.type !== "video"){
                        fd.append("img", 2)
                    }
                    fd.append("file", file.file)
                    let res = await uploadFile(fd)
                    if (res.code === 0) {
                        this.uploadFileSuccess(file, res.data)
                    } else {
                        this.uploadFileError(file, res.msg || "上传失败")
                    }
                } else {
                    // 文件大于1M 切片上传
                    let chunks = Math.ceil(file.size / this.chunkSize)
                    let chunk = 0

                    // 切片上传时，需要获取加密值，切片大小的共用一个加密值
                    // 这里需要请求两次，一次是切片大小的，一个是最后一个切片大小的
                    // 获取切片的加密值
                    let chunk_last = getFileChunk(file.file, this.chunkSize, chunks - 1)
                    let auth_chunk_size = await getUploadAuth({
                        ext: file.ext,
                        size: this.chunkSize,
                        md5: file.md5
                    })
                    let auth_chunk_last = await getUploadAuth({
                        ext: file.ext,
                        size: chunk_last.size,
                        md5: file.md5
                    })

                    // Fn - 使用递归控制切片按照顺序同步上传
                    const uploadChunk = async () => {
                        let item = getFileChunk(file.file, this.chunkSize, chunk)
                        let auth_chunk
                        if (item.size !== this.chunkSize) {
                            auth_chunk = auth_chunk_last.data
                        } else {
                            auth_chunk = auth_chunk_size.data
                        }

                        // 上传切片
                        let fd = new FormData()
                        fd.append("md5", file.md5)
                        fd.append("sourceType", 15)
                        fd.append("size", item.size)
                        fd.append("chunks", chunks)
                        fd.append("chunk", chunk)
                        if (this.type === "img") {
                            fd.append("img", 1)
                        }else if(this.type !== "video"){
                            fd.append("img", 2)
                        }
                        fd.append("ext", file.ext)
                        fd.append("auth", auth_chunk)
                        fd.append("file", item.chunk, file.name)
                        let res = await uploadFile(fd)
                        if (res.code === 0) {
                            chunk ++
                            if (chunk < chunks) {
                                return await uploadChunk()
                            } else {
                                return true
                            }
                        } else {
                            return false
                        }
                    }

                    // 上传切片
                    let uploadRes = await uploadChunk()
                    if (!uploadRes) {
                        this.uploadFileError(file, "上传切片失败")
                        return
                    }

                    // 切片全部上传完，执行合并操作
                    let mergeReq = {
                        md5: file.md5,
                        ext: file.ext,
                        sourceType: 15,
                        size: file.size,
                        auth: file.auth,
                        chunks: chunks,
                        forceMerge: 1
                    }
                    if (this.type === "img") {
                        mergeReq.img = 1
                    }else if(this.type !== "video"){
                        mergeReq.img = 2
                    }
                    let mergeRes = await uploadFileMerge(mergeReq)
                    if (mergeRes.code === 0) {
                        this.uploadFileSuccess(file, mergeRes.data)
                    } else {
                        this.uploadFileError(file, mergeRes.msg)
                    }
                }
            },
            // 单个文件上传成功
            uploadFileSuccess(file, data) {
                let { path, time, width, height } = data
                file.status = "success"
                file.path = path
                if (this.type === "img") {
                    file.width = width
                    file.height = height
                } else if (this.type === "audio") {
                    file.time = time
                } else if (this.type === "video") {
                    file.width = width
                    file.height = height
                    file.time = time
                }
                this.emitRes()
            },
            // 单个文件上传失败
            uploadFileError(file, tip) {
                file.status = "error"
                this.$Message.error(`${file.name}: ${tip}`)
                this.emitRes()
            },
            // 移除文件
            removeFile(index) {
                this.fileList.splice(index, 1)
                this.emitRes()
            },
            // 返回结果
            emitRes() {
                if (this.fileList.every(file => file.status !== "uploading")) {
                    // 上传完成了
                    this.$emit("on-uploaded", this.fileList.filter(file => file.status === "success"),this.dataIndex)
                } else {
                    // 还没上传完成
                    this.$emit("on-uploaded", null,this.dataIndex)
                }
               
            },
            init() {
                this.fileList = []
            }
        }
    }
</script>

<style lang="scss">
    .upload-file {
        width: 100%;
        .uf_lists {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            .uf_list {
                width: 120px;
                height: 120px;
                background: #f6f7f9;
                border-radius: 4px;
                margin: 0 15px 15px 0;
                .uploading,
                .success,
                .error {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    position: relative;
                    .icon-bg {
                        width: 22px;
                        height: 22px;
                    }
                    .tip {
                        font-family: MicrosoftYaHei;
                        line-height: 19px;
                        margin: 10px 0;
                    }
                    .name {
                        font-size: 12px;
                        color: #A0A7B8;
                        width: 90%;
                        text-align: center;
          
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        
                    }
                    .remove {
                        width: 16px;
                        height: 16px;
                        background: url("./remove.png");
                        background-size: 100%;
                        position: absolute;
                        top: -8px;
                        right: -8px;
                        cursor: pointer;
                    }
                }
                .uploading {
                    .icon-bg {
                        @keyframes myRotate {
                            0% {
                                transform: rotate(0deg);
                            }
                            50% {
                                transform: rotate(180deg);
                            }
                            100% {
                                transform: rotate(360deg);
                            }
                        }
                        animation: myRotate 2s linear infinite;
                        background: url("./loading.png");
                        background-size: 100%;
                    }
                }
                .success {
                    .icon-bg {
                        background: url("./success.png");
                        background-size: 100%;
                    }
                    .img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                        border-radius: 4px;
                    }
                }
                .error {
                    .icon-bg {
                        background: url("./warning.png");
                        background-size: 100%;
                    }
                }
                &.uf_upload {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    user-select: none;
                    .icon-bg {
                        width: 22px;
                        height: 22px;
                        background: url("./upload.png");
                        background-size: 100%;
                    }
                    .tip {
                        height: 19px;
                        font-family: MicrosoftYaHei;
                        line-height: 19px;
                        margin-top: 10px;
                        color: #999;
                        font-size: 14px;
                        position: absolute;
                        width: 100%;
                        left: 0;
                        bottom: -10px;
                    }
                }
            }
        }
    }
</style>
